import { FileBlob, FormResponseData } from "./FormTypes";

export const FORM_API_ENDPOINT =
  "https://tpuw8d8thb.execute-api.ap-southeast-2.amazonaws.com/prod/process";

export const submitForm = async (formData: FormResponseData) => {
  const response = await fetch(FORM_API_ENDPOINT, {
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
    body: JSON.stringify(formData),
  });
  return response;
};

export const uploadFiles = (fileBlobs?: Record<string, FileBlob>) => {
  if (!fileBlobs) {
    return;
  }
  return Promise.all(
    Object.values(fileBlobs).map((blob) => {
      return fetch(blob.url, {
        method: "put",
        headers: {
          "content-type": "binary/octet-stream",
        },
        body: blob.file,
      });
    })
  );
};
